import LabServiceCollection from "@/collections/LabServiceCollection";
import TestPackageSampleModel from "../../models/lab/TestPackageSampleModel";

/**
 * TestPackageSample collection
 */
export default class TestPackageSampleCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return TestPackageSampleModel;
  }

}
